import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import UpdateClientForm from "./UpdateClientForm";
import UpdateButtonTrigger from "../../../../../../shared/components/button/UpdateButtonTrigger";

const UpdateClientDialog = ({ client, onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<UpdateButtonTrigger />}
      title="clients.updateForm.title"
      description="clients.updateForm.description"
      content={<UpdateClientForm client={client} onSubmitHandler={onSubmit} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default UpdateClientDialog;
